<!-- @format -->

<template>
	<pc-card
		:id="item.code"
		class="card"
		:style="{
			backgroundColor: item.pcProps.backgroundColor,
			color: item.pcProps.fontColor,
			'--label-color': item.pcProps.labelColor || '',
		}"
		:header="item.pcProps.isHiddenLabel ? '' : item.pcProps.label"
	>
		<template v-if="!item.children.length && status === 'widget'">
			<el-empty class="not-content" :image-size="50" description="请从左侧拖拽字段" />
		</template>
		<slot></slot>
	</pc-card>
</template>

<script setup lang="ts">
	import type { Container } from '../../types';
	import { PcCard } from '@/components';

	interface Props {
		item: Container;
	}
	withDefaults(defineProps<Props>(), {});

	const status = inject('form-status', 'widget');
</script>

<style scoped lang="scss">
	.card {
		width: 100%;

		:deep(.el-card__body) {
			.not-content {
				height: 100px;
				width: 100%;
				position: absolute;
			}

			.widget-form {
				min-height: 100px;
			}

			.el-form-item__label {
				color: var(--label-color, --el-text-color-regular);
			}
		}
	}
</style>
